// Lightweight WebAudio sound effects for public games (no assets needed).
let _ctx = null;
let _muted = false;

export function setMuted(v) {
  _muted = !!v;
}

export function isMuted() {
  return _muted;
}

function ac() {
  if (!_ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _ctx = new AC();
  }
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
}

function tone(freq, { type = "triangle", start = 0, dur = 0.3, vol = 0.1 } = {}) {
  const c = ac();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  const t0 = c.currentTime + start;
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.linearRampToValueAtTime(vol, t0 + 0.02);
  g.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
  o.connect(g);
  g.connect(c.destination);
  o.start(t0);
  o.stop(t0 + dur + 0.05);
}

export function playTick() {
  if (_muted) return;
  try {
    tone(950, { type: "square", dur: 0.045, vol: 0.05 });
  } catch {}
}

// Decelerating wheel ticks over ~durationMs.
export function playSpin(durationMs = 3200) {
  if (_muted) return;
  let elapsed = 0;
  let interval = 55;
  const step = () => {
    if (_muted || elapsed >= durationMs) return;
    playTick();
    elapsed += interval;
    interval = Math.min(320, interval * 1.08);
    setTimeout(step, interval);
  };
  step();
}

export function playWin() {
  if (_muted) return;
  try {
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) =>
      tone(f, { start: i * 0.12, dur: 0.38, vol: 0.11 })
    );
  } catch {}
}

export function playLose() {
  if (_muted) return;
  try {
    tone(392, { type: "sine", dur: 0.3, vol: 0.08 });
    tone(261.63, { type: "sine", start: 0.18, dur: 0.45, vol: 0.08 });
  } catch {}
}
